import { inject, Injectable } from "@angular/core";
import { ApiHttpService } from "@itm/services";

@Injectable({ providedIn: 'root' })
export class CoreSupplierService {
    private readonly http = inject(ApiHttpService);

    constructor() { }
    
    getCreditorCodesByAbn<T>(abn: string){
        const url = `core/supplier/cc/${abn}`;
        return this.http.GETT<T>(url);
    }
}